import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function DateRenderer({ value, onChange, readOnly }: FieldRendererProps) {
  const dateValue = typeof value === 'string' && value ? new Date(value) : null;
  return (
    <DatePicker
      value={dateValue}
      onChange={(e) => onChange(e.value ? e.value.toISOString() : null)}
      disabled={readOnly}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'DAT',
  label: 'Date',
  category: 'input',
  icon: <FontAwesomeIcon icon={faCalendarDays} fixedWidth />,
  defaultProps: { label: 'New date field', isRequired: false },
  Renderer: DateRenderer,
};
